<template>
  <div class="container mb-4">
    <div class="row">
      <div class="col-lg-8 col-12 mx-auto">
        <div class="modal-content mb-auto">
          <div class="modal-header border-0 px-4 pt-4 pb-0">
            <div class="col-12 d-flex">
              <button
                type="button"
                class="btn btn-link ml-auto"
                @click="close"
              >
                Annuler
              </button>
            </div>
          </div>
          <div class="modal-body px-4 pt-0">
            <div class="row">
              <img
                class="col-10 img-fluid mx-auto mt-4"
                style="height: 150px"
                :src="aws + img"
              >
              <div class="col-10 text-center mx-auto">
                <h4 class="text-primary font-weight-bold">
                  Relancez {{ client.firstName }} {{ client.lastName }}
                </h4>
              </div>
              <div class="col-10 text-center mx-auto mt-2">
                Choisissez comment relancer votre ami {{ client.firstName }} {{ client.lastName }}
                et obtenez 10 € sur votre prochaine souscription
                à un contrat Assurup.
              </div>
              <div class="col-12 col-md-10 mx-auto my-4">
                <div class="d-flex flex-column">
                  <button
                    type="button"
                    class="btn btn-yellow-300"
                    @click="clipboardCopy"
                  >
                    Copier le lien
                    <font-awesome-icon
                      icon="link"
                    />
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary my-3"
                    @click="resendEmail"
                  >
                    Relancer par e-mail
                    <font-awesome-icon
                      icon="envelope"
                    />
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="openFacebookDialog"
                  >
                    Inviter via Messenger
                    <font-awesome-icon
                      :icon="['fab', 'facebook-messenger']"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      id="shadowModalPromo"
      :value="shortUrl"
      type="text"
      style="opacity:0; height:0px"
    >
  </div>
</template>
<script>
import { routing, ui } from '@/mixins';
import getShortUrl from '@/services/vendors/tinyurl';

export default {
  name: 'SponsorshipModal',
  mixins: [routing, ui],
  data() {
    return {
      shortUrl: '',
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/img/`,
    img: () => 'unicorn-fairy.svg',
    client() {
      return this.$store.getters['sponsorship/current'];
    },
    credentials() {
      return this.$store.getters['client/clientCredentials'];
    },
    clientId() {
      if (this.credentials) {
        return this.credentials.clientId;
      }
      return null;
    },
  },
  watch: {
    clientId: {
      handler(value) { this.buildShortUrl(value) },
    },
  },
  created() {
    if (this.clientId) {
      this.buildShortUrl(this.clientId);
    }
  },
  methods: {
    close() {
      this.ui_showModal(false);
    },
    async resendEmail() {
      await this.$store.dispatch('sponsorship/resendEmail');
      this.ui_showToast({ show: true, message: 'E-mail de relance envoyé !' });
    },
    buildShortUrl(value) {
      const host = import.meta.env.NODE_ENV === 'production' ? 'https://app.assurup.com' : 'http://dev.app.assurup.com';
      const url = `${host}/sponsorship?id=${value}`;
      getShortUrl(url).then(({ data }) => { this.shortUrl = data });
    },
    async clipboardCopy() {
      const copyText = document.getElementById('shadowModalPromo');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.ui_showToast({ show: true, message: 'Lien de parrainage copié !' });
    },
    openFacebookDialog() {
      this.$store.dispatch('facebook/shareLink', { link: this.shortUrl, redirectUri: 'app.assurup.com/client' });
    },
  },
};
</script>
